var map = {
	"./books-cart.jpg": 8695,
	"./books-home.jpg": 3347,
	"./books-summary.jpg": 370,
	"./crm-business-card.jpg": 4938,
	"./crm-calendar.jpg": 6834,
	"./crm-criteria.jpg": 5101,
	"./crm-enroll.jpg": 5341,
	"./crm-onboarding.jpg": 5079,
	"./crm-sms.jpg": 8254,
	"./k20apartamenty-contact.jpg": 2864,
	"./k20apartamenty-gallery.jpg": 8924,
	"./k20apartamenty-home.jpg": 8091,
	"./portfolio.jpg": 1853,
	"./tutore-dashboard.jpg": 5789,
	"./tutore-form.jpg": 6829,
	"./tutore-map.jpg": 4857,
	"./tutore-partners-home.jpg": 4579,
	"./tutore-quizz.jpg": 9368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5127;